import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "width",
	height: "height",
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Microphone" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2.5C11.2044 2.5 10.4413 2.81607 9.87868 3.37868C9.31607 3.94129 9 4.70435 9 5.5V12.5C9 13.2956 9.31607 14.0587 9.87868 14.6213C10.4413 15.1839 11.2044 15.5 12 15.5C12.7956 15.5 13.5587 15.1839 14.1213 14.6213C14.6839 14.0587 15 13.2956 15 12.5V5.5C15 4.70435 14.6839 3.94129 14.1213 3.37868C13.5587 2.81607 12.7956 2.5 12 2.5Z",
			stroke: "#0399FF",
			strokeWidth: "strokeWidth",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 10.5V12.5C19 14.3565 18.2625 16.137 16.9497 17.4497C15.637 18.7625 13.8565 19.5 12 19.5C10.1435 19.5 8.36301 18.7625 7.05025 17.4497C5.7375 16.137 5 14.3565 5 12.5V10.5",
			stroke: "#0399FF",
			strokeWidth: "strokeWidth",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 19.5V22.5",
			stroke: "#0399FF",
			strokeWidth: "strokeWidth",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMic;
